/**
 * Settings that used to be baked into each client's build (VITE_*). They are now read when the page loads
 * from /config.js (window.__PAYROLL_CONFIG__, written per stack at deploy time), so one build serves every
 * stack. A key missing there falls back to the build-time value, so existing builds keep working.
 */
export interface RuntimeConfig {
  apiUrl: string
  govtCalc: string
  enableCompany: boolean
  enableCost: boolean
}

type Raw = Partial<Record<'apiUrl' | 'govtCalc' | 'enableCompany' | 'enableCost', string | boolean>>

function raw(): Raw {
  try {
    return ((globalThis as any).__PAYROLL_CONFIG__ as Raw) ?? {}
  } catch {
    return {}
  }
}

const text = (v: unknown, fallback: string) => (v === undefined || v === null ? fallback : String(v))

export function readConfig(): RuntimeConfig {
  const r = raw()
  const env = import.meta.env
  return {
    // '' means the page's own origin, which is what a single endpoint for every tenant wants
    apiUrl: text(r.apiUrl, env.VITE_API_URL ?? '').replace(/\/+$/, ''),
    govtCalc: text(r.govtCalc, env.VITE_GOVT_CALC ?? ''),
    enableCompany: text(r.enableCompany, env.VITE_ENABLE_COMPANY ?? '') !== 'false',
    enableCost: text(r.enableCost, env.VITE_ENABLE_COST ?? '') === 'true'
  }
}

export const config: RuntimeConfig = readConfig()

/** Base address of the API, e.g. https://payroll.applive.io/api */
export const API = config.apiUrl + '/api'
